export const VOICE_COPY_EN = {
  stageHead: 'Voice call',
  introTitle: ['Hear a Voice AI agent turn', 'a question into a decision'],
  introBody:
    "Pick an industry and call. You'll talk to an AI agent that recommends a product, answers the hard question about price or commitment, and lands on a concrete next step — a delivery choice, a booked consultation, or a service visit on the calendar.",
  startCall: 'Start call',
  connecting: 'Connecting…',
  endCall: 'End call',
  mute: 'Mute',
  unmute: 'Unmute',
  requestMic: 'Allow microphone',
  showExamples: 'See examples',
  close: 'Close',
  showMore: 'Show more',
  collapse: 'Collapse',
  switchScenario: 'Switch demo scenario',
  startersHeading: 'Try starting with one of these',
  callEnded: 'Call ended',
  connectedAnnounce: "You're connected",
  connectingAnnounce: 'Connecting',
  micBlockedTitle: 'Your microphone is blocked',
  micBlockedHint: 'Allow it from the address bar',
  micAllowToast: 'Please allow microphone access',
  micLive: 'Your microphone is live. Go ahead and speak.',
  slowConnect: 'This is taking longer than usual…',
  reconnecting: 'Your connection is unstable',
  genericError: 'Something went wrong. Please try again.',
  ipRateLimit: "That's a lot of attempts. Please try again in a moment.",
  agentRateLimit: 'All lines are busy right now. Please try again in a moment.',
  maxDuration: 'The demo call reached its time limit, so we ended the call.',
  hiddenEnd: 'We ended the call after a stretch of silence.',
  otherTab: "A call started in another tab, so we're ending this one.",
  connectingTo: (scenario) =>
    `Connecting you to ${scenario.agent} at ${scenario.business}`,
  privacyPolicy: 'Privacy Policy',
  termsOfService: 'Terms of Service',
  privacyUrl: 'https://sendbird.com/privacy-notice',
  termsUrl: 'https://sendbird.com/terms',
  disclaimer:
    "*This demo uses fictional businesses built to show the quality of Delight Voice AI. It runs on live speech recognition and AI-generated responses, so every product, price, time slot, and policy you hear is sample data — it may be inaccurate or differ from any real service. Nothing said on the call creates a real order, booking, or visit, and no one will call you back. Please don't share personal, payment, or health information. The agent will tell you it's an AI if you ask. Best experienced on a desktop browser."
}

export default VOICE_COPY_EN
